/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { SvgIcon, SvgIconProps } from '@material-ui/core';

// TODO create reusable Icon component with size property
const GrafanaIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 64 64">
    <>
      <defs id="defs5">
        <rect
          id="SVGID_1_"
          x="-849.70001"
          y="-1412.2"
          width="4355.2002"
          height="5636.2002"
        />
      </defs>
      <clipPath id="SVGID_2_">
        <use
          xlinkHref="#SVGID_1_"
          style={{ overflow: 'visible' }}
          id="use7"
          x="0"
          y="0"
          width="100%"
          height="100%"
        />
      </clipPath>

      <defs id="defs33">
        <path
          d="m 1229.6,328.6 c 0,0 -0.7,2.9 -1.6,7.8 -8.3,2.4 -16.6,4.7 -24.9,7.4 -11.5,3.5 -22.8,7.7 -34.3,11.8 -11.3,4.4 -22.8,8.8 -34,13.8 -22.6,9.7 -45,20.6 -66.9,32.9 -21.2,11.9 -42.1,25 -62.4,39.2 -2.9,-1.4 -5.2,-2.4 -5.2,-2.4 -207.3,-79.2 -391.4,16.1 -391.4,16.1 -16.8,220.5 82.8,359.5 102.5,384.7 -4.9,13.6 -9.5,27.4 -13.7,41.3 -15.3,50 -26.8,101.3 -33.9,154.3 -1,7.6 -1.9,15.3 -2.8,23 -191.5,94.6 -248.3,288.5 -248.3,288.5 159.9,183.9 346.3,195.3 346.3,195.3 0.2,-0.1 0.3,-0.3 0.5,-0.4 23.7,42.3 51.1,82.6 82,120.1 12.9,15.7 26.5,30.9 40.6,45.6 -58.3,166.7 8.2,305.4 8.2,305.4 178,6.7 294.9,-77.9 319.5,-97.4 17.7,6 35.7,11.3 53.8,16 54.7,14.1 110.7,22.4 166.7,24.8 14,0.6 28,0.9 41.9,0.8 h 6.8 l 4.4,-0.1 8.8,-0.3 8.7,-0.4 0.2,0.3 c 83.8,119.6 231.3,136.5 231.3,136.5 104.9,-110.6 110.9,-220.3 110.9,-244 v 0 c 0,0 0,-0.8 0,-1.6 0,-2 -0.1,-3.3 -0.1,-3.3 0,0 0,0 0,0 -0.1,-1.7 -0.1,-3.3 -0.3,-5.1 22,-15.4 43,-32 62.9,-49.8 42,-38 78.7,-81.2 109.1,-127.9 2.9,-4.4 5.7,-8.8 8.4,-13.3 118.7,6.8 202.4,-73.5 202.4,-73.5 -19.7,-123.7 -90.2,-184 -104.9,-195.4 v 0 c 0,0 -0.6,-0.5 -1.5,-1.1 -0.8,-0.6 -1.4,-1 -1.4,-1 0,0 0,0 0,0 -0.7,-0.5 -1.6,-1.1 -2.6,-1.7 0.7,-7.5 1.4,-14.9 1.8,-22.3 0.9,-13.3 1.2,-26.7 1.3,-39.9 l -0.1,-9.9 -0.1,-5 v -2.5 c 0,-3.4 -0.1,-2.1 -0.1,-3.4 l -0.4,-8.3 -0.6,-11.2 c -0.2,-3.9 -0.5,-7.2 -0.8,-10.7 -0.3,-3.4 -0.6,-6.9 -1,-10.3 l -1.2,-10.3 -1.4,-10.2 c -2,-13.6 -4.6,-27.1 -7.7,-40.4 -12.4,-53.3 -33.2,-103.9 -60.7,-149.4 -27.5,-45.5 -61.7,-85.8 -100.2,-119.7 -38.5,-34 -81.7,-61.3 -127,-81.7 -45.3,-20.4 -92.9,-33.5 -140.3,-39.5 -23.7,-3.1 -47.3,-4.3 -70.7,-4 l -8.7,0.2 -2.2,0.1 c -0.6,0 -3.3,0.1 -3,0.1 l -3.6,0.2 -8.7,0.6 c -3.3,0.2 -6.7,0.5 -9.6,0.8 -12,1.2 -23.9,2.8 -35.7,5 -47,8.8 -91.4,25.8 -130.5,49.2 -39.1,23.4 -73.1,52.7 -100.8,85.9 -27.6,33.1 -49.1,69.8 -63.9,107.8 -14.8,38 -23.1,77.2 -25.4,115.3 -0.6,9.5 -0.8,19 -0.6,28.4 0,2.3 0.1,4.7 0.2,7 l 0.3,7.6 c 0.3,4.6 0.7,9.1 1.1,13.6 1.9,19.3 5.4,37.8 10.6,55.7 10.3,35.7 26.9,68 47.3,95.4 20.4,27.5 44.8,50.2 70.7,67.9 25.9,17.7 53.6,30.4 81,38.5 27.5,8.1 54.8,11.6 80.5,11.5 3.2,0 6.4,-0.1 9.6,-0.2 1.7,0 3.4,-0.2 5.1,-0.2 1.7,-0.1 3.4,-0.2 5.1,-0.3 2.7,-0.3 5.5,-0.5 8.2,-0.8 0.6,0 1.5,-0.2 2.3,-0.3 l 2.5,-0.3 c 1.7,-0.2 3.3,-0.5 5,-0.7 3.4,-0.4 6.3,-1.1 9.3,-1.6 3,-0.6 6,-1.2 9,-2 5.9,-1.3 11.6,-3.1 17.3,-4.8 11.2,-3.7 21.7,-8.2 31.5,-13.2 9.8,-5 18.8,-10.7 27.2,-16.6 2.4,-1.7 4.7,-3.5 7,-5.3 9,-7 10.4,-20.2 3.2,-29 -6.3,-7.7 -17.1,-9.7 -25.7,-4.9 -2.1,1.2 -4.3,2.3 -6.5,3.4 -7.5,3.6 -15.3,7 -23.6,9.7 -8.3,2.6 -16.9,4.8 -25.9,6.4 -4.5,0.6 -9,1.3 -13.6,1.7 -2.3,0.3 -4.6,0.4 -7,0.4 -2.3,0.1 -4.8,0.3 -6.9,0.2 -2.2,0 -4.4,-0.1 -6.7,-0.1 -2.8,-0.1 -5.6,-0.3 -8.4,-0.4 0,0 -1.4,0 -0.3,-0.1 l -0.9,-0.1 -1.9,-0.2 c -1.3,-0.1 -2.5,-0.2 -3.8,-0.4 -2.5,-0.3 -5,-0.6 -7.5,-1 -20.1,-2.8 -40.5,-8.7 -60.1,-17.6 -19.7,-8.9 -38.5,-21.1 -55.5,-36.4 -17,-15.2 -31.8,-33.6 -43.4,-54.4 -11.6,-20.7 -19.7,-43.8 -23.5,-68 -1.9,-12.1 -2.7,-24.6 -2.4,-36.8 0.2,-3.4 0.3,-6.7 0.5,-10.1 0,0.9 0.1,-0.5 0.1,-0.6 l 0.1,-1.2 0.2,-2.5 c 0.1,-1.7 0.3,-3.3 0.5,-5 0.7,-6.6 1.7,-13.3 2.9,-19.8 9.3,-52.7 35.7,-104.1 76.5,-143.2 10.2,-9.7 21.2,-18.8 32.9,-26.8 11.7,-8 24.2,-15.2 37.2,-21.2 13,-6 26.6,-10.9 40.5,-14.7 13.9,-3.7 28.2,-6.2 42.7,-7.5 7.2,-0.6 14.5,-0.9 21.8,-0.9 1.9,0 3.4,0.1 4.9,0.1 l 5.9,0.2 3.7,0.1 c 1.5,0 0,0 0.7,0.1 l 1.5,0.1 5.9,0.4 c 15.7,1.3 31.4,3.5 46.8,7 30.9,6.9 60.9,18.2 88.9,33.7 56,31 103.7,79.5 133,138 14.8,29.1 25,60.5 30.2,92.9 1.2,8.1 2.2,16.3 2.9,24.5 l 0.5,6.2 0.3,6.2 c 0.1,2.1 0.1,4.1 0.2,6.2 0,2 0.1,4.3 0.1,5.8 v 5.3 l -0.1,6 c -0.2,4 -0.5,10.5 -0.7,14.5 -0.7,8.9 -1.4,17.9 -2.6,26.8 -1.1,8.8 -2.6,17.6 -4.2,26.4 -1.8,8.7 -3.6,17.4 -5.9,26 -4.3,17.3 -9.9,34.2 -16.4,50.8 -13.1,33.2 -30.6,64.7 -51.7,93.8 -42.3,58.1 -100,105.6 -165.6,135.4 -32.8,14.8 -67.4,25.7 -103,31.6 -17.8,3 -35.8,4.8 -53.8,5.4 l -3.3,0.1 h -2.9 l -5.8,0.1 h -8.9 -4.4 c 2.5,0 -0.4,0 -0.3,-0.1 l -1.8,-0.1 c -9.7,-0.2 -19.3,-0.7 -28.9,-1.4 -38.5,-2.9 -76.6,-9.7 -113.5,-20.5 -36.9,-10.7 -72.7,-25 -106.6,-43 -67.7,-36.2 -128.2,-85.8 -175.6,-145.6 -23.8,-29.8 -44.6,-61.8 -61.8,-95.5 -17.2,-33.7 -30.7,-69 -40.7,-105.1 -9.9,-36.1 -16.1,-73.1 -18.5,-110.3 l -0.4,-7 -0.1,-1.7 v -1.5 l -0.1,-3.1 -0.2,-6.1 -0.1,-1.5 v -2.1 -4.3 l -0.1,-8.7 v -1.7 c 0,0.3 0,0.3 0,-0.6 v -3.4 c 0,-4.5 0.2,-9.1 0.3,-13.6 0.7,-18.4 2.2,-37.3 4.6,-56.2 2.4,-18.9 5.5,-37.9 9.4,-56.8 3.9,-18.8 8.5,-37.5 13.7,-55.8 10.5,-36.7 23.6,-72.3 39.1,-105.9 31.1,-67.3 71.9,-126.6 120.9,-174.4 12.2,-12 24.9,-23.3 38.1,-33.9 13.2,-10.6 26.9,-20.4 41,-29.6 14,-9.3 28.5,-17.7 43.4,-25.5 7.4,-4 15,-7.5 22.6,-11.2 3.8,-1.7 7.7,-3.4 11.5,-5.1 3.8,-1.7 7.7,-3.4 11.6,-4.9 15.5,-6.6 31.5,-12.1 47.5,-17.3 4.1,-1.2 8.1,-2.5 12.1,-3.7 4,-1.3 8.2,-2.2 12.2,-3.4 8.1,-2.3 16.4,-4.2 24.6,-6.3 4.1,-1.1 8.3,-1.8 12.4,-2.7 4.2,-0.9 8.3,-1.8 12.5,-2.6 4.2,-0.8 8.4,-1.5 12.5,-2.3 l 6.3,-1.1 6.3,-1 c 4.2,-0.6 8.4,-1.3 12.6,-1.9 4.7,-0.8 9.5,-1.2 14.2,-1.9 3.9,-0.5 10.2,-1.2 14.1,-1.7 3,-0.3 5.9,-0.6 8.9,-0.9 l 5.9,-0.6 3,-0.3 3.5,-0.2 c 4.8,-0.3 9.5,-0.6 14.3,-0.9 l 7.1,-0.5 c 0,0 2.6,-0.1 0.3,-0.1 l 1.5,-0.1 3,-0.1 c 4.1,-0.2 8.1,-0.4 12.2,-0.6 16.2,-0.5 32.3,-0.5 48.2,0 31.9,1.3 63.2,4.8 93.6,10.4 60.9,11.3 118.2,30.9 170,56.5 51.9,25.4 98.4,56.6 138.8,90.5 2.5,2.1 5,4.3 7.5,6.4 2.5,2.2 4.9,4.3 7.3,6.5 4.9,4.3 9.6,8.8 14.3,13.1 4.7,4.4 9.2,8.9 13.8,13.3 4.4,4.5 8.9,8.9 13.2,13.5 17.1,18.1 33,36.5 47.3,55 28.7,36.9 51.6,74.1 69.9,109.3 1.2,2.2 2.3,4.4 3.4,6.6 1.1,2.2 2.2,4.4 3.2,6.6 2.1,4.3 4.3,8.6 6.2,12.9 2,4.3 4,8.5 5.9,12.7 1.8,4.2 3.6,8.4 5.4,12.4 6.8,16.5 13,32.1 18.1,47 8.4,23.9 14.5,45.5 19.3,64.2 1.9,7.5 9,12.5 16.7,11.8 8,-0.7 14.1,-7.3 14.3,-15.3 0.4,-20.1 -0.1,-43.8 -2.4,-70.8 -3,-33.4 -8.7,-72.1 -20,-114.6 -11.1,-42.5 -27.6,-89 -51.6,-137.3 -24.1,-48.2 -55.5,-98.4 -96.3,-146.9 -15.9,-19 -33.3,-37.8 -52.1,-56.1 28,-111.4 -34.1,-208 -34.1,-208 -107.2,-6.7 -175.4,33.3 -200.7,51.6 -4.2,-1.8 -8.5,-3.6 -12.8,-5.4 -18.3,-7.4 -37,-14.3 -56.3,-20.4 -19.3,-6.1 -39,-11.7 -59.1,-16.4 -20.2,-4.7 -40.7,-8.7 -61.6,-11.9 -3.7,-0.5 -7.3,-1 -11,-1.6 -46.6,-149.4 -180.9,-211.9 -180.9,-211.9 -149.8,94.5 -178.3,227.4 -178.3,227.4"
          id="SVGID_5_"
        />
      </defs>
      <clipPath id="SVGID_6_">
        <use
          height="100%"
          width="100%"
          y="0"
          x="0"
          id="use35"
          style={{ overflow: 'visible' }}
          xlinkHref="#SVGID_5_"
        />
      </clipPath>

      <linearGradient
        gradientTransform="matrix(0,-255.7742,-255.7742,0,2099115.5,-207133.55)"
        y2="8201.71"
        x2="-812.64868"
        y1="8201.71"
        x1="-819.76501"
        gradientUnits="userSpaceOnUse"
        id="SVGID_7_"
      >
        <stop id="stop38" style={{ stopColor: '#FFF200' }} offset="0" />
        <stop id="stop40" style={{ stopColor: '#F15A29' }} offset="1" />
      </linearGradient>

      <defs id="defs11">
        <rect
          height="5636.2002"
          width="4355.2002"
          y="-1412.2"
          x="-849.70001"
          id="SVGID_3_"
        />
      </defs>
      <clipPath id="SVGID_4_">
        <use
          height="100%"
          width="100%"
          y="0"
          x="0"
          id="use13"
          style={{ overflow: 'visible' }}
          xlinkHref="#SVGID_3_"
        />
      </clipPath>

      <g
        id="g937"
        transform="matrix(0.81591244,0,0,0.81591244,-57.832357,129.71853)"
      >
        <rect
          transform="matrix(0.03937938,0,0,0.03937938,57.733299,-162.97104)"
          x="412.70001"
          y="100.8"
          className="st37"
          width="1834.4"
          height="1992.3"
          clipPath="url(#SVGID_6_)"
          id="rect43"
          style={{ fill: 'url(#SVGID_7_)' }}
        />
      </g>
    </>
  </SvgIcon>
);

export default GrafanaIcon;
